const SERVICE = 'merchant/developer'

const listWebhooks = async api => api.setMethod().get().setService(SERVICE).process('/webhook')

const getWebhook = async api => api.setMethod().get().setService(SERVICE).process('/webhook/:webhook_id')

const createWebhook = async (api, body) => api.setMethod().post().setService(SERVICE).setBody(body).process('/webhook')  

const updateWebhook = async (api, params, body) => api.setMethod().post().setService(SERVICE).setBody(body).process('/webhook/:webhook_id', params)

const deleteWebhook = async (api, params) => api.setMethod().delete().setService(SERVICE).process('/webhook/:webhook_id', params)  

module.exports = {
  listWebhooks,
  getWebhook,
  createWebhook,
  updateWebhook,
  deleteWebhook,
}
